import { Injectable } from '@angular/core';
import { Headers, Http, Response } from '@angular/http';
import 'rxjs/Rx';

@Injectable()
export class HttpRequestService {

    constructor(private http: Http) {

    }

    postDocument(collectionUrl, object) {
        const newDocumentJson = JSON.stringify(object);

        const headers = new Headers({
            'Content-Type': 'application/json'
        });

        return this.http.post(collectionUrl, newDocumentJson, {headers}).map(res => {
            // console.log(res.json());
            return res.json();
        });
    }

    getDocuments(collectionUrl) {
        return this.http.get(collectionUrl).map(res => res.json());
    }

    getDocument(documentUrl) {
        return this.http.get(documentUrl).map(res => res.json());
    }

    putDocument(documentUrl, object) {
        const updateDocumentJson = JSON.stringify(object);

        const headers = new Headers({
            'Content-Type': 'application/json'
        });

        return this.http.put(documentUrl, updateDocumentJson, {headers}).map(res => {
            // console.log(res.json());
            return res.json();
        });
    }

    delDocument(documentUrl) {
        return this.http.delete(documentUrl).map(res => res.json());
    }

}

